import styled from 'styled-components'

const HeaderContainer = styled.div<{ $leftIcon: boolean }>`
  width: 100%;
  color: var(--typography500);
  background-color: var(--neutral-theme);
  padding: 16px 24px;
  display: flex;
  justify-content: ${({ $leftIcon }) => ($leftIcon ? 'space-between' : 'center')};
  align-items: center;

  .android-transition {
    &:active {
      transition: 0.4s ease-out;
      background-color: rgba(125, 125, 125, 0.15);
    }
  }
`

const IconPlaceholder = styled.div`
  height: 24px;
  width: 24px;
`

export { HeaderContainer, IconPlaceholder }
